/**
 * Bundle-aware store pickup availability.
 * Prefetches Shopify pickup sections for addresses, then overlays honest
 * per-store status from d1x (available / low / unavailable) — ignores Shopify
 * "available" when Sell when OOS makes empty stores look pickup-ready.
 */
(function () {
  if (window.__d1BundleStoreAvailabilityScriptLoaded) return;
  window.__d1BundleStoreAvailabilityScriptLoaded = true;

  var BATCH_SIZE = 4;
  var DEFAULT_STOCK_API = 'https://d1x.d1store.app/api/public/store-pickup-stock';
  var cache = {}; // variantId -> { locationName -> { available, state, ... } } Shopify section
  var stockCache = {}; // variantId -> { locationName -> 'available'|'low'|'unavailable' } | null on fail
  var inflight = {};
  var prefetchStarted = false;

  (function (w) {
    if (w.__d1PickupStock) return;
    var stockMem = {};
    var stockWait = {};
    function nid(value) {
      var m = String(value || '').match(/(\d+)\s*$/);
      return m ? m[1] : '';
    }
    function byName(item) {
      var map = {};
      var locs = (item && item.locations) || [];
      for (var i = 0; i < locs.length; i++) {
        var loc = locs[i];
        if (!loc || !loc.name) continue;
        var status = loc.status;
        if (status !== 'available' && status !== 'low' && status !== 'unavailable') continue;
        map[String(loc.name).trim()] = status;
      }
      return map;
    }
    function itemsFromPayload(json) {
      var data = json && json.data ? json.data : json;
      if (data && data.items) return data.items;
      if (data && data.locations) return [data];
      return [];
    }
    function storeRow(id, item) {
      stockMem[id] = { locations: (item && item.locations) || [], byName: byName(item) };
    }
    function fetchLegacy(apiBase, chunk) {
      return Promise.all(chunk.map(function (id) {
        var url = String(apiBase || '').replace(/\/$/, '') + '?variantId=' + encodeURIComponent(id);
        return fetch(url, { credentials: 'omit' })
          .then(function (res) {
            if (!res.ok) throw new Error('stock');
            return res.json();
          })
          .then(function (json) {
            if (json && json.success === false) throw new Error('stock fail');
            storeRow(id, json && json.data ? json.data : json);
          })
          .catch(function () {
            stockMem[id] = null;
          });
      }));
    }
    function fetchChunk(apiBase, chunk) {
      var url = String(apiBase || '').replace(/\/$/, '') + '?variantIds=' + encodeURIComponent(chunk.join(','));
      return fetch(url, { credentials: 'omit' }).then(function (res) {
        // ponytail: live API is still single-variant until middleware ships
        if (!res.ok) return fetchLegacy(apiBase, chunk);
        return res.json().then(function (json) {
          if (json && json.success === false) return fetchLegacy(apiBase, chunk);
          itemsFromPayload(json).forEach(function (item) {
            var id = nid(item && item.variantId);
            if (id) storeRow(id, item);
          });
          chunk.forEach(function (id) {
            if (!Object.prototype.hasOwnProperty.call(stockMem, id)) {
              stockMem[id] = { locations: [], byName: {} };
            }
          });
        });
      });
    }
    function fetchMany(apiBase, ids) {
      var wanted = [];
      var seen = {};
      (ids || []).forEach(function (raw) {
        var id = nid(raw);
        if (!id || seen[id]) return;
        seen[id] = true;
        wanted.push(id);
      });
      var missing = wanted.filter(function (id) {
        return !Object.prototype.hasOwnProperty.call(stockMem, id) && !stockWait[id];
      });
      var started = Promise.resolve();
      if (missing.length) {
        missing.sort();
        var chunks = [];
        for (var c = 0; c < missing.length; c += 10) chunks.push(missing.slice(c, c + 10));
        started = chunks.reduce(function (prev, chunk) {
          return prev.then(function () { return fetchChunk(apiBase, chunk); });
        }, Promise.resolve()).catch(function () {
          missing.forEach(function (id) { stockMem[id] = null; });
        });
        missing.forEach(function (id) { stockWait[id] = started; });
        started.then(function () {
          missing.forEach(function (id) { delete stockWait[id]; });
        });
      }
      return Promise.all(wanted.map(function (id) { return stockWait[id] || started; }));
    }
    w.__d1PickupStock = {
      fetchMany: fetchMany,
      get: function (id) { return stockMem[nid(id)]; },
      forget: function (id) { delete stockMem[nid(id)]; },
    };
  })(window);

  function rootUrl() {
    var el = document.querySelector('pickup-availability');
    var root = (el && el.dataset.rootUrl) || '/';
    return root.endsWith('/') ? root : root + '/';
  }

  function stockApiBase() {
    var el = document.querySelector('pickup-availability');
    var url = (el && el.dataset.pickupStockApi) || DEFAULT_STOCK_API;
    return String(url).replace(/\/$/, '');
  }

  function skipSkuList() {
    var el = document.querySelector('pickup-availability');
    return String((el && el.dataset.skipStoreAvailabilitySkus) || '')
      .split(',')
      .map(function (s) {
        return s.trim().toUpperCase();
      })
      .filter(Boolean);
  }

  function currentVariantSku() {
    var el = document.querySelector('pickup-availability');
    if (el && el.dataset.variantSku) return String(el.dataset.variantSku).trim().toUpperCase();
    var json = document.querySelector('variant-selects [data-selected-variant]');
    if (!json) return '';
    try {
      var v = JSON.parse(json.textContent);
      return String((v && v.sku) || '').trim().toUpperCase();
    } catch (_) {
      return '';
    }
  }

  function skipStoreAvailability(sku) {
    var key = String(sku || currentVariantSku() || '').trim().toUpperCase();
    return Boolean(key && skipSkuList().indexOf(key) !== -1);
  }

  function normalizeId(value) {
    var n = parseInt(String(value || ''), 10);
    return Number.isFinite(n) && n > 0 ? String(n) : '';
  }

  function readListingConfig() {
    var el = document.getElementById('d1-bundle-listing-atc-config');
    if (!el) return null;
    try {
      var c = JSON.parse(el.textContent);
      if (!c || !(c.parentVariantId > 0)) return null;
      return c;
    } catch (_) {
      return null;
    }
  }

  function getMainVariantId() {
    var listing = readListingConfig();
    if (listing && listing.parentVariantId) {
      return normalizeId(listing.parentVariantId);
    }

    var form =
      document.querySelector('form[action*="/cart/add"]') ||
      document.querySelector('product-form form');
    if (form) {
      var input = form.querySelector('input[name="id"], select[name="id"]');
      var fromForm = normalizeId(input && input.value);
      if (fromForm) return fromForm;
    }
    var pickup = document.querySelector('pickup-availability');
    return normalizeId(pickup && pickup.dataset.variantId);
  }

  function getSelectedAccessoryIds() {
    var listing = readListingConfig();
    if (listing && Array.isArray(listing.accessoryIds) && listing.accessoryIds.length) {
      return listing.accessoryIds
        .map(function (id) {
          return normalizeId(id);
        })
        .filter(Boolean);
    }

    var input = document.querySelector('[data-d1-bundle-tiers] [data-d1-bundle-tier-input]:checked');
    if (!input) return [];
    var row = input.closest('[data-d1-tier-wrapper]');
    if (!row || row.style.display === 'none' || row.classList.contains('is-none-tier')) return [];
    return String(row.getAttribute('data-accessory-ids') || '')
      .split(',')
      .map(function (s) {
        return normalizeId(s.trim());
      })
      .filter(Boolean);
  }

  function parseSectionHtml(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var map = {};
    doc.querySelectorAll('.pickup-availability-card').forEach(function (card) {
      var titleEl = card.querySelector('.pickup-availability-card__title');
      var name = titleEl ? titleEl.textContent.trim() : '';
      if (!name) return;
      var metaEl = card.querySelector('.pickup-availability-card__meta');
      var addressEl = card.querySelector('.pickup-availability-card__address');
      var phoneEl = card.querySelector('.pickup-availability-card__phone');
      map[name] = {
        available: card.classList.contains('pickup-availability-card--available'),
        state: card.getAttribute('data-d1-state') || '',
        meta: metaEl ? metaEl.innerHTML : '',
        addressHtml: addressEl ? addressEl.innerHTML : '',
        phoneHtml: phoneEl ? phoneEl.innerHTML : '',
      };
    });
    return map;
  }

  function fetchVariantAvailability(variantId) {
    variantId = normalizeId(variantId);
    if (!variantId) return Promise.resolve(null);
    if (Object.prototype.hasOwnProperty.call(cache, variantId)) return Promise.resolve(cache[variantId]);
    if (inflight[variantId]) return inflight[variantId];

    var url = rootUrl() + 'variants/' + variantId + '/?section_id=pickup-availability';
    inflight[variantId] = fetch(url)
      .then(function (res) {
        if (!res.ok) throw new Error('pickup ' + variantId);
        return res.text();
      })
      .then(function (text) {
        var parsed = parseSectionHtml(text);
        cache[variantId] = parsed;
        delete inflight[variantId];
        return parsed;
      })
      .catch(function () {
        cache[variantId] = null;
        delete inflight[variantId];
        return null;
      });

    return inflight[variantId];
  }

  function fetchStockBatch(ids) {
    var list = (ids || []).map(normalizeId).filter(Boolean);
    if (!list.length || skipStoreAvailability()) return Promise.resolve();
    return window.__d1PickupStock.fetchMany(stockApiBase(), list).then(function () {
      list.forEach(function (id) {
        var row = window.__d1PickupStock.get(id);
        stockCache[id] = row ? row.byName : null;
      });
    });
  }

  function prefetchIds(ids) {
    var i = 0;
    var stockP = fetchStockBatch(ids);
    function nextBatch() {
      if (i >= ids.length) return Promise.resolve();
      var batch = ids.slice(i, i + BATCH_SIZE);
      i += BATCH_SIZE;
      return Promise.all(batch.map(fetchVariantAvailability)).then(nextBatch);
    }
    return Promise.all([nextBatch(), stockP]);
  }

  function syncPickupPreviewToMainVariant() {
    var listing = readListingConfig();
    if (!listing) return;
    var main = normalizeId(listing.parentVariantId);
    if (!main) return;
    var pickup = document.querySelector('pickup-availability');
    if (!pickup) return;
    if (pickup.dataset.variantId === main) return;
    pickup.dataset.variantId = main;
    if (typeof pickup.fetchAvailability === 'function') {
      pickup.fetchAvailability(main);
    }
  }

  function startBackgroundPrefetch() {
    if (prefetchStarted) return;
    if (skipStoreAvailability()) return;
    var hasTiers = !!document.querySelector('[data-d1-bundle-tiers]');
    var hasListing = !!readListingConfig();
    if (!hasTiers && !hasListing) {
      // Still warm stock for standard PDPs when drawer can open
      var mainOnly = getMainVariantId();
      if (!mainOnly) return;
    }
    prefetchStarted = true;
    syncPickupPreviewToMainVariant();
    var run = function () {
      var main = getMainVariantId();
      if (main) prefetchIds([main]);
    };
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 3000 });
    } else {
      setTimeout(run, 900);
    }
  }

  function statusRank(status) {
    if (status === 'unavailable') return 3;
    if (status === 'contact') return 2;
    if (status === 'low') return 1;
    if (status === 'available') return 0;
    return 3;
  }

  function worstStatus(a, b) {
    return statusRank(a) >= statusRank(b) ? a : b;
  }

  /**
   * Intersect d1x status maps.
   * Fail closed when the stock API is down — Shopify section `available` is true
   * at empty stores under continue-selling / preorder, so never trust it.
   */
  function intersectStockStatuses(variantIds) {
    var ids = (variantIds || []).map(normalizeId).filter(Boolean);
    if (!ids.length) return { byName: {}, usedStockApi: false };

    var knownStock = ids.filter(function (id) {
      return stockCache[id] && typeof stockCache[id] === 'object';
    });

    if (!knownStock.length) {
      return { byName: {}, usedStockApi: false };
    }

    var byName = {};
    var base = stockCache[knownStock[0]] || {};
    Object.keys(base).forEach(function (name) {
      var status = 'available';
      knownStock.forEach(function (id) {
        var locStatus = (stockCache[id] && stockCache[id][name]) || 'unavailable';
        status = worstStatus(status, locStatus);
      });
      byName[name] = status;
    });
    // Locations present on later variants but not first
    knownStock.slice(1).forEach(function (id) {
      Object.keys(stockCache[id] || {}).forEach(function (name) {
        if (byName[name]) return;
        var status = 'available';
        knownStock.forEach(function (vid) {
          var locStatus = (stockCache[vid] && stockCache[vid][name]) || 'unavailable';
          status = worstStatus(status, locStatus);
        });
        byName[name] = status;
      });
    });
    return { byName: byName, usedStockApi: true };
  }

  function ensureNote(drawer, text) {
    var host = drawer.querySelector('.pickup-availability-drawer-top') || drawer;
    var note = host.querySelector('[data-d1-bundle-avail-note]');
    if (!note) {
      note = document.createElement('p');
      note.className = 'pickup-availability-variant caption';
      note.setAttribute('data-d1-bundle-avail-note', '');
      var filters = host.querySelector('.pickup-availability-filters');
      if (filters) host.insertBefore(note, filters);
      else host.appendChild(note);
    }
    note.textContent = text;
    note.hidden = !text;
  }

  var STATUS_COPY = {
    available: { label: 'Available today', meta: 'Ready within 4 business hours' },
    low: { label: 'Limited stock', meta: 'Call store to confirm' },
    contact: { label: 'Call to confirm', meta: 'Call the store to confirm stock before visiting' },
    unavailable: { label: 'Not available', meta: '' },
  };

  // status: 'available' | 'low' | 'contact' | 'unavailable'
  function setCardStatus(card, status) {
    var copy = STATUS_COPY[status] || STATUS_COPY.unavailable;
    card.classList.toggle('pickup-availability-card--available', status === 'available');
    card.classList.toggle('pickup-availability-card--partial', status === 'low' || status === 'contact');
    card.classList.toggle('pickup-availability-card--low', status === 'low');
    card.classList.toggle('pickup-availability-card--contact', status === 'contact');
    card.classList.toggle('pickup-availability-card--unavailable', status === 'unavailable');

    var statusEl = card.querySelector('.pickup-availability-card__status');
    if (!statusEl) {
      statusEl = document.createElement('span');
      var top = card.querySelector('.pickup-availability-card__top');
      if (top) top.appendChild(statusEl);
      else card.prepend(statusEl);
    }
    var statusKind = status === 'low' || status === 'contact' || status === 'available' ? status : 'unavailable';
    statusEl.className = 'pickup-availability-card__status pickup-availability-card__status--' + statusKind;
    statusEl.textContent = copy.label;

    var meta = card.querySelector('.pickup-availability-card__meta');
    if (copy.meta) {
      if (!meta) {
        meta = document.createElement('p');
        meta.className = 'pickup-availability-card__meta caption';
        var heading = card.querySelector('.pickup-availability-card__top');
        if (heading && heading.nextSibling) card.insertBefore(meta, heading.nextSibling);
        else card.appendChild(meta);
      }
      meta.textContent = copy.meta;
      meta.hidden = false;
    } else if (meta) {
      meta.textContent = '';
      meta.hidden = true;
    }
  }

  function sortCardsInStockFirst(drawer) {
    if (typeof window.sortPickupStoreCards === 'function') {
      window.sortPickupStoreCards(drawer);
      return;
    }
    var list = drawer.querySelector('[data-store-availability-drawer-content]');
    if (!list) return;
    var cards = Array.prototype.slice.call(list.querySelectorAll('.pickup-availability-card'));
    cards.sort(function (a, b) {
      function rank(card) {
        if (card.classList.contains('pickup-availability-card--available')) return 0;
        if (card.classList.contains('pickup-availability-card--low')) return 1;
        if (card.classList.contains('pickup-availability-card--contact')) return 2;
        return 3;
      }
      return rank(a) - rank(b);
    });
    cards.forEach(function (card) {
      list.appendChild(card);
    });
  }

  function applyToDrawer(drawer, variantIds) {
    if (!drawer) return;
    var intersected = intersectStockStatuses(variantIds);
    var byName = intersected.byName;
    var cards = drawer.querySelectorAll('.pickup-availability-card');
    // Stock API down → contact, don't claim unavailable (we simply don't know)
    var fallbackStatus = intersected.usedStockApi ? 'unavailable' : 'contact';

    cards.forEach(function (card) {
      var titleEl = card.querySelector('.pickup-availability-card__title');
      var name = titleEl ? titleEl.textContent.trim() : '';
      var status = byName[name] || fallbackStatus;
      setCardStatus(card, status);
    });

    sortCardsInStockFirst(drawer);
    drawer.setAttribute('data-d1-stock-applied', 'true');
    ensureNote(drawer, intersected.usedStockApi ? '' : 'Live stock unavailable — contact stores to confirm.');

    var active = drawer.querySelector('.pickup-availability-filters [data-d1-filter].is-active');
    if (active && typeof window.applyPickupStoreFilter === 'function') {
      window.applyPickupStoreFilter(drawer, active.getAttribute('data-d1-filter') || 'ALL');
    }
  }

  function selectedVariantIds() {
    var main = getMainVariantId();
    var accessories = getSelectedAccessoryIds();
    var ids = [];
    if (main) ids.push(main);
    accessories.forEach(function (id) {
      if (ids.indexOf(id) === -1) ids.push(id);
    });
    return ids;
  }

  function prepareDrawer() {
    if (skipStoreAvailability()) return Promise.resolve();
    var ids = selectedVariantIds();
    return prefetchIds(ids).then(function () {
      var drawer = document.querySelector('pickup-availability-drawer');
      applyToDrawer(drawer, ids);
    });
  }

  window.D1BundleStoreAvailability = {
    prepareDrawer: prepareDrawer,
    startBackgroundPrefetch: startBackgroundPrefetch,
    selectedVariantIds: selectedVariantIds,
  };

  document.addEventListener('change', function (e) {
    if (!e.target || !e.target.matches) return;

    if (e.target.matches('[data-d1-bundle-tier-input]')) {
      var openDrawer = document.querySelector('pickup-availability-drawer[open]');
      if (openDrawer) prepareDrawer();
      return;
    }

    if (e.target.name === 'id' || e.target.matches('[name="id"]')) {
      if (skipStoreAvailability()) return;
      var main = getMainVariantId();
      if (main) {
        delete stockCache[main];
        if (window.__d1PickupStock) window.__d1PickupStock.forget(main);
        prefetchIds([main]);
      }
    }
  });

  document.addEventListener('DOMContentLoaded', startBackgroundPrefetch);
  if (document.readyState !== 'loading') startBackgroundPrefetch();
  document.addEventListener('product-info:loaded', function () {
    prefetchStarted = false;
    startBackgroundPrefetch();
  });
})();
